import './index.scss'
$("header .nav li").eq(2).addClass("active");
$(".case-container ul").eq(0).addClass("active");
$(".pro-nav ul li").click(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".case-container ul").eq(index).addClass("active").siblings().removeClass("active");
})